import React from "react";
import CodeSnippet from "../index-sections/CodeSnippet.js";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

import Navbar from "components/Navbars/IndexNavbar";
import Header from "components/Headers/IndexHeader";
import Footer from "components/Footers/DemoFooter.js";

function Dispatcher() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        {/* Navbar */}
        <Navbar />

        {/* Header */}
        <Header />
        
        {/* Inizio del contenuto della pagina */}
        <div className="main">
            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Dispatcher</h2>
                            {/* Descrizione */}
                            <h5 className="description" style={{color: 'black'}}>
                                Attraverso di esso Node.js è in grado di differenziare le chiamate effettuate dall'utente (client) e puo essere utilizzato per andare a gestire le diverse "pagine" di un sito (come nell'esempio seguente)
                            </h5>
                            <br />
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}

                {/* INIZIO CODICE JAVASCRIPT - server.js */}
                {/* Inizio snippet del codice */}
                <CodeSnippet
                    language="javascript"
                    description="Dopo aver importato i moduli per l'HTTP e per la gestione degli URL vado a parsare il contenuto del mio URL e successivamente vado ad effettuare uno switch sul percorso andando in questo caso ad identificare le diverse 'pagine' del mio sito, il percorso (path) contenente solo lo slash (/) equivale alla mia pagina home (root)."
                    code={`let http = require("http")
let url = require("url")

http.createServer((req, res) => {

    /*
    Dal momento che uso "True" --> ottengo un object literal --> posso accedere con .{nomeVariabile}
    Dal momento che uso "False" --> ottengo una stringa --> devo fare lo split...
    Di default l'impostazione è "False"
    */
    let mioURL = url.parse(req.url, true)

    //Switch sull'url
    switch (mioURL.path) {
        case "/":
            res.end("HOME PAGE")
            break;
        case "/pluto":
            res.end("PAGINA WEB PLUTO")
            break;
        case "/topolino":
            res.end("PAGINA WEB TOPOLINO")
            break;
        default:
            res.end("Messaggio 1")
            break;
    }
}).listen("3000")`}
            />
                    {/* Fine snippet del codice */}
                    {/* FINE CODICE JAVASCRIPT - server.js */}

            </div>

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/dispathcer" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}
            
        </div>
        {/* Fine del contenuto della pagina */}
        
        {/* Footer */}
        <Footer />
    </>
  );
}

export default Dispatcher;
